import Segment from "@components/buttons/Segment";

type Props = {
  count: number;
  setValue: (value: boolean) => void;
  skipSpacing?: boolean;
  value: boolean;
};

const ArchiveSegment = ({ count, setValue, skipSpacing = false, value }: Props) => {
  const buttons = [
    {
      maxWidth: 200,
      textKey: "pages.carePlan.base.goals.active",
      value: "false"
    },
    {
      maxWidth: 200,
      textKey: "pages.carePlan.base.goals.archive",
      value: "true"
    }
  ];

  return (
    <Segment
      buttons={buttons}
      count={count}
      onChange={v => {
        setValue(JSON.parse(v));
      }}
      skipSpacing={skipSpacing}
      value={value.toString()}
    />
  );
};

export default ArchiveSegment;
